module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLogin),
      expression: "showLogin"
    }],
    attrs: {
      "id": "login"
    }
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "no_login",
    on: {
      "click": _vm.closed
    }
  }, [_vm._v("不领了，谢谢")]), _vm._v(" "), _c('div', {
    staticClass: "go_login",
    on: {
      "click": _vm.goLogin
    }
  }, [_vm._v("立即领取")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5770b080","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 141
// module chunks = 1